import type { ReactNode } from 'react';
import { Icon } from '../icons';
import { Tooltip } from './Tooltip';

/**
 * HelpTip (CO-158): one sentence of help beside a value or a count — what
 * a "stock position" is, say — on hover, keyboard focus and tap, closed
 * with Escape. It is named for what it explains, and it never holds the
 * only copy of a warning, a value or an instruction: those stay on the page.
 *
 * It is a small ghost icon button (CO-178): the same size, corner and focus
 * outline as every other icon control, so it is one family, not a round
 * exception. It carries no `title`, because the tooltip is its text.
 */
export function HelpTip({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Tooltip content={children} toggleOnTap>
      <button type="button" className="icon-button icon-button--ghost icon-button--sm help-tip" aria-label={label}>
        <Icon name="info" size={14} />
      </button>
    </Tooltip>
  );
}
